import {
    FETCH_PLAYER_ALERTS,
    FETCH_PLAYER_ALERTS_FAIL,
    FETCH_PLAYER_ALERTS_SUCCESS,
    FETCH_PLAYER_DETAILS,
    FETCH_PLAYER_DETAILS_FAIL,
    FETCH_PLAYER_DETAILS_SUCCESS,
    FETCH_PLAYER_EVENTS,
    FETCH_PLAYER_EVENTS_FAIL,
    FETCH_PLAYER_EVENTS_SUCCESS
} from './actionTypes';

export const fetchPlayerDetails = args => ({
    type: FETCH_PLAYER_DETAILS,
    payload: args
});

export const fetchPlayerDetailsSuccess = response => ({
    type: FETCH_PLAYER_DETAILS_SUCCESS,
    payload: response
});

export const fetchPlayerDetailsFail = error => ({
    type: FETCH_PLAYER_DETAILS_FAIL,
    payload: error
});

export const fetchPlayerEvents = args => ({
    type: FETCH_PLAYER_EVENTS,
    payload: args
});

export const fetchPlayerEventsSuccess = response => ({
    type: FETCH_PLAYER_EVENTS_SUCCESS,
    payload: response
});

export const fetchPlayerEventsFail = error => ({
    type: FETCH_PLAYER_EVENTS_FAIL,
    payload: error
});

export const fetchPlayerAlerts = args => ({
    type: FETCH_PLAYER_ALERTS,
    payload: args
});

export const fetchPlayerAlertsSuccess = response => ({
    type: FETCH_PLAYER_ALERTS_SUCCESS,
    payload: response
});

export const fetchPlayerAlertsFail = error => ({
    type: FETCH_PLAYER_ALERTS_FAIL,
    payload: error
});
